import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './imageSlider.css';

export class Imageslider extends Component{
    render(){
        return(
            <div id="myCarousel" className="carousel slide" data-ride="carousel">
            <ol className="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
                <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol>
            <div className="carousel-inner">
                <div className="carousel-item active">
                <img className="first-slide img-fluid" src="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/mainbanner.jpg?alt=media&token=14b27dcd-a94b-4030-bf18-8eed4ac713a1" alt="First slide" />
                <div className="container">
                    <div className="carousel-caption text-center">
                    <h1>Wellcome to Board of Intermediate Education Karachi.</h1>
                    <p>This is Official Website of Board of Intermediate Education Karachi.</p>
                    </div>
                </div>
                </div>
                <div className="carousel-item">
                <img className="second-slide img-fluid" src="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/MobilePhone.jpg?alt=media&token=4a502d22-6576-4053-b9e9-07dc4bb82577" alt="Second slide" />
                <div className="container">
                    <div className="carousel-caption text-center">
                    <h1>Want's Result on your Mobile?</h1>
                    <p>Type "BIEK" &lt;space&gt; Your Roll# and send it to 8583.</p>
                    <p><a className="btn btn-lg btn-primary" href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/MobilePhone.jpg?alt=media&token=4a502d22-6576-4053-b9e9-07dc4bb82577" role="button">Learn more</a></p>
                    </div>
                </div>
                </div>
                <div className="carousel-item">
                <img className="third-slide img-fluid" src="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/WhatsApp%20Image%202018-04-11%20at%201.55.08%20PM.jpeg?alt=media&token=65014d94-3298-4e84-b809-fcf8740ba366" alt="Third slide" />
                <div className="container">
                    <div className="carousel-caption text-center">
                    <h1>No Cheating.</h1>
                    <p>Chief Minister Mr. Murad Ali Shah gave Strickly Order to board.</p>
                    <p><a className="btn btn-lg btn-primary" href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/WhatsApp%20Image%202018-04-11%20at%201.55.08%20PM.jpeg?alt=media&token=65014d94-3298-4e84-b809-fcf8740ba366" role="button">Learn More</a></p>
                    </div>
                </div>
                </div>
                <div className="carousel-item">
                <img className="third-slide img-fluid" src="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/WhatsApp%20Image%202018-04-11%20at%201.56.53%20PM.jpeg?alt=media&token=5b89139a-799c-4bc0-865d-2c916a5fa4a1" alt="Third slide" />
                <div className="container">
                    <div className="carousel-caption text-center">
                    <h1>Two Girls win the 1st position in Board Exams.</h1>
                    <p>Two young girls Study Hard to give exams and take 1st position from Karachi.</p>
                    <p><Link className="btn btn-lg btn-primary" to="/activities" role="button">Browse gallery</Link></p>
                    </div>
                </div>
                </div>
            </div> 
                        <a className="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="sr-only">Next</span>
                        </a>
        </div>
        )
    }
}